
    import './styles.scoped.css';
    export default {
  "breadcrumb-group": "awsui_breadcrumb-group_d19fg_oihv1_141",
  "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_oihv1_176",
  "ghost": "awsui_ghost_d19fg_oihv1_187",
  "item": "awsui_item_d19fg_oihv1_192",
  "ghost-item": "awsui_ghost-item_d19fg_oihv1_193",
  "ellipsis": "awsui_ellipsis_d19fg_oihv1_194",
  "hide": "awsui_hide_d19fg_oihv1_205",
  "visible": "awsui_visible_d19fg_oihv1_211",
  "icon": "awsui_icon_d19fg_oihv1_215",
  "breadcrumbs-skeleton": "awsui_breadcrumbs-skeleton_d19fg_oihv1_221",
  "collapsed-button": "awsui_collapsed-button_d19fg_oihv1_225",
  "button-icon": "awsui_button-icon_d19fg_oihv1_307",
  "button-icon-open": "awsui_button-icon-open_d19fg_oihv1_321",
  "hidden": "awsui_hidden_d19fg_oihv1_325"
};
  